import { useTheme } from "@emotion/react";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { useMemo } from "react";

export default function StatsTable({ stats }) {
  const { palette } = useTheme();

  const sortedStats = useMemo(
    () => stats.sort((a, b) => b.value - a.value),
    [stats]
  );

  const getColor = (value) => {
    if (value > 15) return palette.secondary[300];
    if (value > 10) return palette.secondary[500];
    if (value > 5) return palette.secondary[700];

    return palette.secondary[800];
  };

  return (
    <>
      <Paper
        id="stats-table"
        sx={{ boxShadow: `0 0 5px ${palette.divider}`, p: 2 }}
      >
        {sortedStats.map(({ category, value }) => (
          <Grid container key={category} spacing={2}>
            <Grid xs={5} smd={4}>
              <Typography textAlign="end" variant="body2">
                {category}
              </Typography>
            </Grid>
            <Grid xs={5} alignSelf="center">
              <LinearProgress
                variant="determinate"
                value={value * 5}
                size="md"
                sx={{
                  width: "100%",
                  borderRadius: 5,
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: getColor(value),
                  },
                }}
              />
            </Grid>
            <Grid xs={2} smd={3}>
              <Typography
                textAlign="start"
                variant="body2"
                sx={{ color: getColor(value), fontWeight: "bold" }}
              >
                {value}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Paper>
    </>
  );
}
